import { registerComponent } from "helpers";
import WYATTElement from "wyatt";

registerComponent(
  "bulk-order",
  class BulkOrder extends WYATTElement {
    connectedCallback() {
      this.searchContent = this.querySelector("[data-search-content]");
      this.collectionContent = this.querySelector("[data-collection-content]");

      this.subscribe(
        WYATT.PubSub.events.bulkSearch,
        this.updateContent.bind(this),
      );
    }

    updateContent(event) {
      const { detail } = event;
      if (!detail) {
        if (!this.collectionContent.checkVisibility()) {
          this.collectionContent.classList.remove("hidden");
        }

        this.searchContent.replaceChildren();
      } else {
        const [newSearchDOM] = detail;
        this.searchContent.replaceChildren();
        this.updateDOM.append(this.searchContent, newSearchDOM);
        this.collectionContent.classList.add("hidden");
      }
    }

    disconnectedCallback() {
      super.disconnectedCallback();
    }
  },
);
